export const availableLocale = [
  {
    text: "Italiano",
    value: "it",
    rtl: false,
    img: require("@/assets/flags/italy.svg"),
  },
  {
    text: "中文",
    value: "zh",
    rtl: false,
    img: require("@/assets/flags/china.svg"),
  },
  {
    text: "English",
    value: "en",
    rtl: false,
    img: require("@/assets/flags/united-states.svg"),
  },
/*  
  {
    text: "عربى",
    value: "ar",
    rtl: false,
    img: require("@/assets/flags/saudi-arabia.svg"),
  },
  {
    text: "Русский",
    value: "ru",
    rtl: false,
    img: require("@/assets/flags/russia.svg"),
  }*/
  
];
export const availableCurrency = [
  {
    text: "$",
    value: "usd",
    img: require("@/assets/currencies/usd.svg"),
  },
  {
    text: "元",
    value: "cny",
    img: require("@/assets/currencies/cny.svg"),
  },
  {
    text: "€",
    value: "eur",
    img: require("@/assets/currencies/eur.svg"),
  }
];
export default {
  locale: navigator.language.substring(0,2),
  currency: "eur",
  rtl: false,
};
